import { render, staticRenderFns } from "./EmergencyContactsCard.vue?vue&type=template&id=18112242"
import script from "./EmergencyContactsCard.vue?vue&type=script&lang=js"
export * from "./EmergencyContactsCard.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContactsCard.vue?vue&type=style&index=0&id=18112242&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports